import { render } from "./Ventas.vue?vue&type=template&id=4c7a7f6b"
import script from "./Ventas.vue?vue&type=script&lang=js"
export * from "./Ventas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/rpasii/Ventas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c7a7f6b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c7a7f6b', __exports__)) {
    api.reload('4c7a7f6b', __exports__)
  }
  
  module.hot.accept("./Ventas.vue?vue&type=template&id=4c7a7f6b", () => {
    api.rerender('4c7a7f6b', render)
  })

}


export default __exports__